import { FormEvent, useState } from "react";
import { useI18n } from "../i18n";

type FormState = "idle" | "submitting" | "success" | "error";

export function LeadForm() {
  const [state, setState] = useState<FormState>("idle");
  const [message, setMessage] = useState("");
  const { t } = useI18n();

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setState("submitting");
    setMessage("");

    const form = new FormData(event.currentTarget);
    try {
      const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "https://vpn-api.fluxbrowser.cn";
      const response = await fetch(`${apiBaseUrl}/api/v1/leads`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          email: form.get("email"),
          source: "homepage-waitlist",
        }),
      });

      const result = (await response.json()) as {
        data?: { message?: string };
        error?: { message?: string };
      };

      if (!response.ok) throw new Error(result.error?.message ?? "提交失败，请稍后重试。");
      setState("success");
      setMessage(result.data?.message ?? "提交成功！");
      event.currentTarget.reset();
    } catch (error) {
      setState("error");
      setMessage(error instanceof Error ? error.message : "提交失败，请稍后重试。");
    }
  }

  return (
    <form className="lead-form" onSubmit={handleSubmit}>
      <label className="sr-only" htmlFor="waitlist-email">{t("邮箱地址")}</label>
      <input
        id="waitlist-email"
        name="email"
        type="email"
        placeholder={t("输入邮箱，获取开放测试通知")}
        autoComplete="email"
        required
      />
      <button className="button" type="submit" disabled={state === "submitting"}>
        {t(state === "submitting" ? "提交中…" : "免费获取通知")}
      </button>
      {message && <p className={`form-message ${state}`} role="status">{t(message)}</p>}
    </form>
  );
}
